import styled, { css } from 'styled-components'

export const Wrapper = styled.span``
